import { setupFormState } from '@/components/form/tidal-form'
import type { DriverAssistanceFormValues } from '../../types'

export const initialValues: DriverAssistanceFormValues = {
  type: 'NONE',
  checkIn: false,
  checkOut: false,
  includePicture: 'DO_NOT_REQUIRE',
  includePictureChecked: false,
  includeSignature: 'DO_NOT_REQUIRE',
  includeSignatureChecked: false,
  includeAudio: 'DO_NOT_REQUIRE',
  includeAudioChecked: false,
  includeNote: 'DO_NOT_REQUIRE',
  includeNoteChecked: false,
  includeStatusChecked: true,
}

export const form = setupFormState<DriverAssistanceFormValues>({
  id: 'driver-assistance-form',
  initialValues,
})
